// extracted by mini-css-extract-plugin
export default {"div":"ButtonToggle_div__HW+5s","lrg":"ButtonToggle_lrg__inusd","selected":"ButtonToggle_selected__timaZ"};